import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useCallback, useMemo, useState } from "react";
import { useStyles } from "./styles";

type ArtImageProps = {
  name: string;
  image: string;
  onClick?: () => void;
  overlayComponent?: any;
};

export function ArtImage({
  overlayComponent,
  onClick,
  name,
  image = "https://datasalesio-imagens.s3.amazonaws.com/empty_image_propaganda_02.png",
}: ArtImageProps) {
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const styles = useStyles();

  const altImage = useMemo(() => {
    return `image-${name}`;
  }, [name]);

  const handleMouse = useCallback(() => {
    if (Boolean(overlayComponent)) {
      setShowOverlay((prevState) => !prevState);
    }
  }, [overlayComponent]);

  return (
    <Stack spacing={1}>
      <div
        onMouseEnter={handleMouse}
        onMouseLeave={handleMouse}
        className={styles.root}
      >
        {showOverlay && (
          <div className={styles.overlay}>
            {overlayComponent}
            <div style={{ flex: 1 }} onClick={onClick} />
          </div>
        )}
        <img className={styles.image} src={image} alt={altImage} />
      </div>
      <Typography variant="caption">{name}</Typography>
    </Stack>
  );
}
